export default "__VITE_ASSET__B3zekRG$__"